import React from 'react';

/**
 * GroupedInputBox: 여러 입력 필드를 하나의 둥근 박스로 묶어 표시하는 공통 컴포넌트.
 * 각 slot 사이에 divider가 들어가고, 배경은 bg-mono-50.
 *
 * @param {ReactNode[]} children - 각 slot에 들어갈 콘텐츠 (배열)
 * @param {string} className - 추가 wrapper class
 */
export default function GroupedInputBox({ children, className = '' }) {
  const slots = React.Children.toArray(children).filter(Boolean);
  const last = slots.length - 1;

  return (
    <div className={`border border-mono-200 rounded-xl ${className}`}>
      {slots.map((child, i) => (
        <div key={i}>
          {i > 0 && <div className="border-t border-mono-100 mx-4" />}
          <div className={`bg-mono-50 ${i === 0 ? 'rounded-t-xl' : ''} ${i === last ? 'rounded-b-xl' : ''}`}>
            {child}
          </div>
        </div>
      ))}
    </div>
  );
}
